<template>
    <div>
          <el-dialog
            title="优惠券详情"
            :visible.sync="showDialog"
            width="60%"
            :before-close="handleClose"
            >
             <el-row>
                 <el-col :span="24">
                        <div class="modelTitel">基础信息</div>
                 </el-col>
                 <el-col>
                      <el-form label-width="170px">
                          <el-col :span="24" class="h35">
                                <el-form-item label="券类型:">
                                      <span>代金券</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="券名称:">
                                      <span>5折券</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="券面值:">
                                      <span>10.00元</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="使用有效期:">
                                      <span>领取后当天生效,有效期90天</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="适用商品:">
                                      <span>全部商品</span>
                                </el-form-item>
                          </el-col>
                      </el-form>
                 </el-col>
             </el-row>
             <el-row class="mt30">
                 <el-col :span="24">
                    <div class="modelTitel">优惠券适用规则</div>
                 </el-col>
                 <el-col>
                 <el-form label-width="170px">
                  <el-col :span="24" class="h35">
                                <el-form-item label="券类型:">
                                      <span>无</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="单笔订单最多可用:">
                                      <span>1张</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="每人每天最多可用:">
                                      <span>不限制</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="叠加使用规则:">
                                      <span>不可与其他优惠券叠加使用</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="活动同享规则:">
                                      <span>不可与其他优惠活动同享</span>
                                </el-form-item>
                          </el-col>
                           <el-col :span="24" class="h35">
                                <el-form-item label="转赠规则:">
                                      <span>不可转增给好友</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="可用渠道:">
                                      <span>全部渠道</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="关联公众号:">
                                      <span>不指定</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="关联商家微信小程序:">
                                      <span>不指定</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="不可用日期:">
                                      <span>无</span>
                                </el-form-item>
                          </el-col>
                           <el-col :span="24" class="h35">
                                <el-form-item label="不可用时段:">
                                      <span>无</span>
                                </el-form-item>
                          </el-col>
                        </el-form>
                     </el-col>
             </el-row>
             <el-row class="mt30">
                 <el-col :span="24">
                    <div class="modelTitel">其他信息</div>
                 </el-col>
                 <el-col>
                 <el-form label-width="170px">
                  <el-col :span="24" class="h35">
                                <el-form-item label="三方生态:">
                                      <span>美团餐饮Saas</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="详细使用规则:">
                                      <span>显示</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="券说明:">
                                      <span>无</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="券备注:">
                                      <span>无</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="适用场景:">
                                      <span>不限制</span>
                                </el-form-item>
                          </el-col>
                        </el-form>
                     </el-col>
             </el-row>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
          </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            showDialog:false,
        }
    },
      props:{
        dialogVisible:{
            type: Boolean,
            default:false,
        }
     },
     watch:{
        dialogVisible:{
            handler(newVal,oldVal){
                this.showDialog = newVal
            },
            deep:true,
            immediate:true,
        }
     },
     created(){
     },
     methods:{
        confirm(){
           this.$emit('handleClose',false)
           this.showDialog = false
        },
        handleClose(){
             this.$emit('handleClose',false)
             this.showDialog = false
        }
     }
}
</script>

<style lang="less" scoped>
.modelTitel{
    font-size: 17px;
    position: relative;
    padding-left: 20px;
}
.modelTitel::before{
    content: " ";
    width: 5px;
    height: 23px;
    background: rgb(245,154,35);
    position: absolute;
    left: 0;
    bottom: 3px;
} 
/deep/ .el-dialog__header{
    border-bottom: 1px solid #ddd;
}
/deep/ .el-dialog__footer{
    border-top:1px solid #ddd;
}
/deep/ .el-form-item__label{
    color: #999;
}
.h35{
    height: 35px;
} 
.mt30{
    margin-top: 30px;
}
/deep/ .el-dialog {
  margin-top: 7vh !important;
}
/deep/ .el-dialog__body{
    height: 67vh;
    overflow-y: scroll;
    padding:30px 60px ;
}
</style>